<template>
  <div>
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="editado.resultado"
              rounded
              filled
              dense
              background-color="transparent"
              color="secondary"
              label="Resultado"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="editado.observaciones"
              rounded
              filled
              dense
              auto-grow
              rows="3"
              background-color="transparent"
              color="secondary"
              label="Observaciones"
            ></v-textarea>
          </v-col>
          <v-col cols="12" align="center">
            <div class="text-subtitle-1 font-weight-bold">Fecha de emisión C3 <span class="red--text">*</span></div>
            <v-date-picker
              v-model="editado.fechaVigenciaEvaluacionC3"
              locale="es"
              color="secondary"
              no-title
              full-width
            ></v-date-picker>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-btn color="secondary" class="primary--text px-8 col-12 justify-center" :loading="loading" @click="guardar">
      Editar registro
    </v-btn>
  </div>
</template>

<script>
import DateAdapter from '@/utils/DateAdapter'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { NotificationFactory, NOTIFICATION_TYPES } from '@/modules/notificaciones/domain/NotificationFactory'
import Notificacion from '@/modules/notificaciones/domain/Notificacion'
import moment from 'moment'

export default {
  props: {
    resultadoC3: {
      type: Object,
      required: true,
    },
    idPersonal: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      editado: { ...this.resultadoC3 },
      loading: false,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
  },
  watch: {
    resultadoC3: {
      handler(val) {
        let fecha = null
        if (val.fechaVigenciaEvaluacionC3) {
          try {
            const fechaNormalizada = val.fechaVigenciaEvaluacionC3.replace('a. m.', 'AM').replace('p. m.', 'PM')
            fecha = moment(fechaNormalizada, 'DD/MM/YYYY hh:mm:ss A').format('YYYY-MM-DD')
          } catch (e) {
            fecha = null
          }
        }
        this.editado = {
          ...val,
          fechaVigenciaEvaluacionC3: fecha,
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions('resultadosPersonalesC3', ['updateResultado']),
    ...mapActions('dialog', ['closeDialog']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('notificaciones', ['createNotification']),

    async guardar() {
      this.loading = true

      const fechaFormateada = this.editado.fechaVigenciaEvaluacionC3
        ? moment(this.editado.fechaVigenciaEvaluacionC3, 'YYYY-MM-DD').format('DD/MM/YYYY hh:mm:ss A')
        : null

      await this.updateResultado({
        idPersonal: this.idPersonal,
        idResultado: this.editado.idResultado,
        resultado: {
          resultado: this.editado.resultado,
          fechaVigenciaEvaluacionC3: fechaFormateada,
          observaciones: this.editado.observaciones,
        },
      })

      await this.sendNotification()

      this.loading = false
      this.closeDialog()
    },

    async sendNotification() {
      try {
        const notification = new NotificationFactory(Notificacion).createNotification(
          NOTIFICATION_TYPES.EMISION_RESULTADO_C3,
          {
            responsable: Number(localStorage.getItem('idPersonal')),
            afectado: this.idPersonal,
            nombrePersonal: this.getFullName(this.personal),
            resultado: this.editado.resultado,
            fechaVigencia: new DateAdapter(this.editado.fechaVigenciaEvaluacionC3, 'YYYY-MM-DD').toUiSupportedFormat(),
          }
        )

        await this.createNotification(notification)
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al notificar emisión de resultados.')
      }
    },
  },
}
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}
</style>
